import { supabase, isSupabaseConfigured } from '@/lib/supabase'
import { RPC_CATALOG } from './rpcCatalog'

function assertSupabase() {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error(
      'Supabase non configuré. Copiez env.example vers .env et renseignez VITE_SUPABASE_*.',
    )
  }
  return supabase
}

function assertRpc(name) {
  if (!RPC_CATALOG[name]) {
    throw new Error(`RPC inconnue: ${name}`)
  }
}

/**
 * Appelle une RPC cataloguée avec gestion d'erreur unifiée.
 * @param {keyof typeof RPC_CATALOG} name
 * @param {Record<string, unknown>} params
 */
export async function callRpc(name, params = {}) {
  assertRpc(name)
  const client = assertSupabase()
  const { data, error } = await client.rpc(name, params)
  if (error) throw error
  return data
}

export async function getCompatibleMatches(userId, limit = 12) {
  return callRpc('get_compatible_matches', {
    user_id_param: userId,
    limit_param: limit,
  })
}

// calculate_compatibility NO se expone al front: revelaría el filtrado
// silent trans (reason=preference_mismatch_silent). Migración 046 / B1.
// El matching pasa siempre por get_compatible_matches.
